import url from "@shared/utils/urls/url";
import { t, useTranslation } from "@shared/constants/utils";
import { SUPPORT_URL_ORGANIZER } from "@shared/constants/links/help-center";

useTranslation("common");

export const FOOTER_DATA = {
  links: [
    {
      id: 1,
      name: t("About Showpass"),
      locale: "en",
      published_at: "2021-09-18T03:44:43.761Z",
      created_at: "2021-09-18T03:39:40.449Z",
      updated_at: "2021-09-18T03:54:41.211Z",
      footer_links: [
        {
          id: 1,
          name: t("About Us"),
          path: "https://showpass.com/sell/about-opportunities",
          footer_category: 1,
          locale: "en",
          published_at: "2021-09-18T03:44:14.267Z",
          created_at: "2021-09-18T03:42:27.953Z",
          updated_at: "2023-07-04T20:24:21.155Z",
        },
        {
          id: 3,
          name: t("Register Organization"),
          path: url("organizations/register"),
          footer_category: 1,
          locale: "en",
          published_at: "2021-09-18T03:44:08.126Z",
          created_at: "2021-09-18T03:43:15.889Z",
          updated_at: "2021-09-21T02:16:51.756Z",
        },
        {
          id: 4,
          name: t("Our Features"),
          path: "https://showpass.com/sell/ticketing-features",
          footer_category: 1,
          locale: "en",
          published_at: "2021-09-18T03:50:43.816Z",
          created_at: "2021-09-18T03:45:11.248Z",
          updated_at: "2023-07-04T20:24:42.936Z",
        },
        {
          id: 5,
          name: t("Pricing"),
          path: "https://showpass.com/pricing",
          footer_category: 1,
          locale: "en",
          published_at: "2021-09-18T03:50:47.044Z",
          created_at: "2021-09-18T03:45:33.299Z",
          updated_at: "2021-09-21T02:16:38.084Z",
        },
        {
          id: 6,
          name: t("Referral Program"),
          path: "https://showpass.com/sell/referral",
          footer_category: 1,
          locale: "en",
          published_at: "2024-06-04T00:00:00.000Z",
          created_at: "2024-06-04T00:00:00.000Z",
          updated_at: "2024-06-04T00:00:00.000Z",
        },
      ],
      localizations: [],
    },
    {
      id: 3,
      name: t("Help & Support"),
      locale: "en",
      published_at: "2021-09-18T03:44:50.301Z",
      created_at: "2021-09-18T03:40:01.836Z",
      updated_at: "2021-09-18T03:59:16.411Z",
      footer_links: [
        {
          id: 6,
          name: t("Privacy Policy"),
          path: "https://showpass.com/privacy-policy",
          footer_category: 3,
          locale: "en",
          published_at: "2021-09-18T03:51:25.221Z",
          created_at: "2021-09-18T03:51:08.969Z",
          updated_at: "2021-09-21T02:16:45.038Z",
        },
        {
          id: 7,
          name: t("Customer Support"),
          path: "https://help.showpass.com/hc/en-us/categories/360001836433-For-Ticket-Buyers",
          footer_category: 3,
          locale: "en",
          published_at: "2021-09-18T03:51:43.862Z",
          created_at: "2021-09-18T03:51:21.460Z",
          updated_at: "2021-09-18T03:59:16.409Z",
        },
        {
          id: 8,
          name: t("Organizer Support"),
          path: SUPPORT_URL_ORGANIZER,
          footer_category: 3,
          locale: "en",
          published_at: "2021-09-18T03:52:02.856Z",
          created_at: "2021-09-18T03:52:01.983Z",
          updated_at: "2021-09-18T03:59:16.409Z",
        },
        {
          id: 11,
          name: t("Terms & Conditions"),
          path: "https://showpass.com/terms",
          footer_category: 3,
          locale: "en",
          published_at: "2021-09-18T03:57:56.732Z",
          created_at: "2021-09-18T03:57:55.786Z",
          updated_at: "2021-09-21T02:17:00.944Z",
        },
        {
          id: 12,
          name: t("Technical Docs"),
          path: "https://dev.showpass.com/",
          footer_category: 3,
          locale: "en",
          published_at: "2025-11-15T20:07:00.000Z",
          created_at: "2025-11-15T20:07:00.000Z",
          updated_at: "2025-11-15T20:07:00.000Z",
        },
      ],
      localizations: [],
    },
    {
      id: 4,
      name: t("Connect With Us"),
      locale: "en",
      published_at: "2021-09-21T13:24:37.581Z",
      created_at: "2021-09-21T13:24:01.105Z",
      updated_at: "2021-09-21T13:24:37.649Z",
      footer_links: [
        {
          id: 9,
          name: t("Careers"),
          path: "https://showpass.com/sell/about-opportunities",
          footer_category: 4,
          locale: "en",
          published_at: "2021-09-18T03:55:00.141Z",
          created_at: "2021-09-18T03:54:22.186Z",
          updated_at: "2022-06-17T08:28:51.233Z",
        },
        {
          id: 10,
          name: t("Blog"),
          path: "https://showpass.com/sell/ticketing-blog",
          footer_category: 4,
          locale: "en",
          published_at: "2021-09-18T03:56:12.764Z",
          created_at: "2021-09-18T03:56:11.821Z",
          updated_at: "2021-09-21T13:24:23.923Z",
        },
      ],
      localizations: [],
    },
  ],
  socialMedia: [
    {
      id: 1,
      name: "Facebook",
      link: "https://www.facebook.com/showpass",
      locale: "en",
      created_at: "2021-09-18T04:00:14.770Z",
      updated_at: "2021-09-18T04:00:14.794Z",
      image: {
        id: 32,
        name: "fb-logo.svg",
        alternativeText: "",
        caption: "",
        width: 8,
        height: 14,
        formats: null,
        hash: "facebook_logo",
        simple_footer_hash: "facebook_logo_gray",
        ext: ".svg",
        mime: "image/svg+xml",
        size: 0.4,
        url: "https://showpass-live.s3.us-west-2.amazonaws.com/media/strapi-cms/fb_logo_f22770eabd.svg",
        previewUrl: null,
        provider: "aws-s3-path",
        provider_metadata: null,
        created_at: "2021-09-18T04:00:10.953Z",
        updated_at: "2021-12-03T20:37:11.381Z",
      },
      localizations: [],
    },
    {
      id: 2,
      name: "Instagram",
      link: "http://instagram.com/ShowpassEvents",
      locale: "en",
      created_at: "2021-09-18T04:03:01.958Z",
      updated_at: "2021-09-18T04:03:01.982Z",
      image: {
        id: 33,
        name: "instagram_logo.svg",
        alternativeText: "",
        caption: "",
        width: 15,
        height: 16,
        formats: null,
        hash: "instagram_logo",
        simple_footer_hash: "instagram_logo_gray",
        ext: ".svg",
        mime: "image/svg+xml",
        size: 3.09,
        url: "https://showpass-live.s3.us-west-2.amazonaws.com/media/strapi-cms/instagram_logo_7d07a357ae.svg",
        previewUrl: null,
        provider: "aws-s3-path",
        provider_metadata: null,
        created_at: "2021-09-18T04:02:56.175Z",
        updated_at: "2021-09-18T04:02:56.195Z",
      },
      localizations: [],
    },
    {
      id: 3,
      name: "LinkedIn",
      link: "https://ca.linkedin.com/company/showpass",
      locale: "en",
      created_at: "2021-09-18T04:03:41.411Z",
      updated_at: "2021-09-18T04:03:41.433Z",
      image: {
        id: 34,
        name: "linkedin_logo.svg",
        alternativeText: "",
        caption: "",
        width: 16,
        height: 16,
        formats: null,
        hash: "linkedin_logo",
        simple_footer_hash: "linkedin_logo_gray",
        ext: ".svg",
        mime: "image/svg+xml",
        size: 0.96,
        url: "https://showpass-live.s3.us-west-2.amazonaws.com/media/strapi-cms/linkedin_logo_d225e07377.svg",
        previewUrl: null,
        provider: "aws-s3-path",
        provider_metadata: null,
        created_at: "2021-09-18T04:03:36.425Z",
        updated_at: "2021-09-18T04:03:36.442Z",
      },
      localizations: [],
    },
    {
      id: 4,
      name: "Twitter",
      link: "https://twitter.com/ShowpassEvents",
      locale: "en",
      created_at: "2021-09-18T04:04:12.126Z",
      updated_at: "2021-09-18T04:04:12.148Z",
      image: {
        id: 35,
        name: "twitter_logo.svg",
        alternativeText: "",
        caption: "",
        width: 19,
        height: 14,
        formats: null,
        simple_footer_hash: "twitter_logo_gray",
        ext: ".svg",
        mime: "image/svg+xml",
        size: 1.55,
        url: "https://showpass-live.s3.us-west-2.amazonaws.com/media/strapi-cms/twitter_logo_fcd48ea3c1.svg",
        previewUrl: null,
        provider: "aws-s3-path",
        provider_metadata: null,
        created_at: "2021-09-18T04:04:06.167Z",
        updated_at: "2021-09-18T04:04:06.187Z",
      },
      localizations: [],
    },
  ],
};
export const SIMPLE_FOOTER_DATA = {
  links: [
    {
      id: 7,
      name: t("Customer Support"),
      path: "https://help.showpass.com/hc/en-us/categories/360001836433-For-Ticket-Buyers",
      footer_category: 3,
      locale: "en",
      published_at: "2021-09-18T03:51:43.862Z",
      created_at: "2021-09-18T03:51:21.460Z",
      updated_at: "2021-09-18T03:59:16.409Z",
    },
    {
      id: 11,
      name: t("Terms & Conditions"),
      path: "https://showpass.com/terms",
      footer_category: 3,
      locale: "en",
      published_at: "2021-09-18T03:57:56.732Z",
      created_at: "2021-09-18T03:57:55.786Z",
      updated_at: "2021-09-21T02:17:00.944Z",
    },
    {
      id: 6,
      name: t("Privacy Policy"),
      path: "https://showpass.com/privacy-policy",
      footer_category: 3,
      locale: "en",
      published_at: "2021-09-18T03:51:25.221Z",
      created_at: "2021-09-18T03:51:08.969Z",
      updated_at: "2021-09-21T02:16:45.038Z",
    },
  ],
};
